import { zIndex } from "../../../theme";
import { styled } from "../../../theme/styled";

export const StyledPopoverBase = styled.div({
  border: "1px solid $border-subtle-non-darkmode",
  boxShadow: "$shadow-hover-list",
  backgroundColor: "$background-tertiary",
  zIndex: zIndex.modal - 1,
});
